import React from "react";
import { ProgressSpinner } from "primereact/progressspinner";
import { BlockUI } from "primereact/blockui";
import CSS from "csstype";
import { Avatar } from "primereact/avatar";

const style: CSS.Properties = {
  zIndex: 9999,
  position: "absolute",
  // marginTop: "50px",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
};

const Loading = () => {
  return (
    <>
      <BlockUI blocked={true} fullScreen></BlockUI>
      <Avatar
        image="/images/logo.png"
        size="large"
        shape="circle"
        style={style}
      />

      <ProgressSpinner style={style} />
    </>
  );
};

export default Loading;
